import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import { amountReadable } from '../utils/functions';

const STRIPE = 'stripe';
const DEFAULT_RATE = 15;
const IN_STORE = 'in store';
const MANUAL = 'manual';
const PLAID = 'plaid';
const MANUAL_PLAID = 'manual_plaid';
const PENDING = 'pending';
const AVAILABLE = 'available';
export const QUARANTINED = 'quarantined';
const EMPTY_LOCATION = 'empty_location';
const INCORRECT_LOCATION = 'incorrect_location';
const DUPLICATE = 'duplicate';
const BLOCKED_ACCOUNT = 'blocked_account';
const BONUS = 'bonus';
const DONATION = 'donation';

export const QUARANTINED_REASONS = {
  [EMPTY_LOCATION]: EMPTY_LOCATION,
  [INCORRECT_LOCATION]: INCORRECT_LOCATION,
  [DUPLICATE]: DUPLICATE,
  [BLOCKED_ACCOUNT]: BLOCKED_ACCOUNT,
};

export const STATES = {
  [PENDING]: PENDING,
  [AVAILABLE]: AVAILABLE,
  [QUARANTINED]: QUARANTINED,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.string,
    name: PropTypes.string,
    place: PropTypes.string,
    amount: PropTypes.number,
    pended: PropTypes.bool,
    rate: PropTypes.string,
    stripeTransactionId: PropTypes.string,
    plaidTransactionId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    storeId: PropTypes.string,
    cashbackType: PropTypes.string,
    source: PropTypes.string,
    transactionAmount: PropTypes.number,
    fastCashId: PropTypes.string,
    userEmail: PropTypes.string,
    userAuth0Id: PropTypes.string,
    state: PropTypes.string,
    quarantinedReason: PropTypes.string,
    availableStates: PropTypes.arrayOf(PropTypes.string),
    userAuth0Id: PropTypes.string,
  },
  {
    hasPlaidTransaction(cashback) {
      return !isNil(this.plaidTransactionId(cashback));
    },
    rateReadable(cashback) {
      const rate = this.rate(cashback);
      if (isNil(rate)) return '--';

      return `${rate}%`;
    },
    amountReadable(cashback) {
      return amountReadable(this.amount(cashback));
    },
    transactionAmountReadable(cashback) {
      return amountReadable(this.transactionAmount(cashback));
    },
    defaultRate() {
      return DEFAULT_RATE;
    },
    defaultPlace() {
      return IN_STORE;
    },
    isInStore(cashback) {
      return this.place(cashback) === IN_STORE;
    },
    isPending(cashback) {
      return this.state(cashback) === PENDING;
    },
    isQuarantined(cashback) {
      return this.state(cashback) === QUARANTINED;
    },
    isAvailable(cashback) {
      return this.state(cashback) === AVAILABLE;
    },
    isSpent(cashback) {
      return this.source(cashback) === STRIPE;
    },
    isManual(cashback) {
      return this.source(cashback) === MANUAL;
    },
    canChangeState(cashback) {
      return !this.isSpent(cashback) && !this.isManual(cashback);
    },
    quarantinedReasonReadable(cashback) {
      const reasonMap = {
        [EMPTY_LOCATION]: 'Location is empty',
        [INCORRECT_LOCATION]: 'Location is incorrect',
        [BLOCKED_ACCOUNT]: 'Blocked account',
        [DUPLICATE]: 'Duplicate account',
      };
      const reason = this.quarantinedReason(cashback);

      return reasonMap[reason];
    },
    isEditable(cashback) {
      return this.hasPlaidTransaction(cashback);
    },
    sourceReadable(cashback) {
      const sourceMap = {
        [MANUAL]: 'Manual',
        [PLAID]: 'Plaid',
        [MANUAL_PLAID]: 'Plaid, added manually',
        [STRIPE]: 'Stripe',
        [BONUS]: 'Bonus',
        [DONATION]: 'Donation',
      };

      const source = this.source(cashback);

      return sourceMap[source];
    },
  }
);
